

export default {

  install (Vue, options) {
    
    const util = {
      keys: (arr) => {
        if (arr === undefined)
          return [];
        if (!Array.isArray(arr))
          return [];
        let keys = [];
        arr.forEach(r => keys = [...keys, ...Object.keys(r)]);
        keys = [...new Set(keys)];
        return keys;
      },
    
      uniqueValues: (arr) => [...new Set(arr)],
    
      uniqueValuesForKey: (arr, key) => {
        return util.uniqueValues(util.valuesForKeyPath(arr, key))
      },
      
      valueForPath: function(obj,is, value) {
        if (typeof is == 'string')
            return util.valueForPath(obj,is.split('.'), value);
        else if (is.length==1 && value!==undefined)
            return obj[is[0]] = value;
        else if (is.length==0)
            return obj;
        else
            return util.valueForPath(obj[is[0]],is.slice(1), value);
      },

      valuesForKeyPath: function(arr, key, willOverwriteNull=false) {
        const result = []; 
        arr.forEach(r=> {
          const val = util.valueForPath(r,key)
          result.push(willOverwriteNull && val === null ? '' : val )
        })

        return result;
      },

      arrayTypesForKeyPath: function(arr, key){
        const result= {}
        arr.forEach(_r=> {
          const r = util.valueForPath(_r, key)
          typeof r === "string" ? result["string"] = 0
          : typeof r === "number" ? result["string"] = 0
          : r instanceof Date ? result["date"] = 0
          : result["other"] = 0
        })
        console.log(result, arr)
        return result
      },

      sortAscForKeyPath: function(arr, key, isAsc=true, willOverwriteNull=false){
        return arr.sort((a,b) => {
          let _a = util.valueForPath(a, key)
          let _b = util.valueForPath(b, key)
          _a = willOverwriteNull && _a === null ? '' : _a
          _b = willOverwriteNull && _b === null ? '' : _b
          return _a > _b ? (isAsc ? 1 : -1)
          : _a < _b ? (isAsc ? -1 : 1) 
          : 0
        })
      },

      sortDescForKeyPath: (arr, key, willOverwriteNull=false) => util.sortAscForKeyPath(arr, key, false, willOverwriteNull),

      objectToArray: function(obj, idKey = 'id', valueKey = 'value'){
        return Object.keys(obj).map(r=>JSON.parse(`{"${idKey}": "${[r]}", "${valueKey}": ${JSON.stringify(obj[r])}}`))
      },

      formatPhoneNumber(phoneNumberString) {
        if(!phoneNumberString){
          return '';
        }
        if(phoneNumberString.startsWith('sip:')){
          return phoneNumberString.match(/sip:([^@]*)/)[1]
        }
        if(phoneNumberString.startsWith('+266696687')){
          return 'Private'
        }
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          return '(' + match[2] + ') ' + match[3] + '-' + match[4]
        }
        return phoneNumberString;
      },

      formatDate : (date, format="MM/DD/YY, h:mm:ss a") =>moment(date).format(format),
      //Format Date
      d: (date, format) => util.formatDate(date, format)

    }

    Vue.prototype.$util = util
    

  }
}